module.exports = __webpack_public_path__ + "img/ieee.2d7ade0b.png";